import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vp-popover" }
const _hoisted_2 = {
  key: 0,
  class: "vp-popover-row"
}
const _hoisted_3 = { class: "vp-popover-value" }
const _hoisted_4 = {
  key: 1,
  class: "vp-popover-row"
}
const _hoisted_5 = { class: "vp-popover-value" }
const _hoisted_6 = { class: "vp-popover-note" }

import { computed } from 'vue';
import moment from 'moment-timezone';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceListUpdated',
  props: {
    params: {}
  },
  setup(__props: any) {

const props = __props;

const relative = computed(() => (props.params.value ? moment(props.params.value).fromNow() : '—'));

// Both stamps share one formatter — they come from the same record, so a time
// on one and not the other just reads as a bug. No `.tz()`: moment formats in
// the viewer's own timezone by default, which is what we want here.
const formatStamp = (value?: string | null) => (value ? moment(value).format('MMMM D, YYYY h:mm A') : '');

const updatedText = computed(() => formatStamp(props.params.data?.updatedAt));

const createdText = computed(() => formatStamp(props.params.data?.createdAt));

const localZone = computed(() => moment.tz.guess());

const hasTooltip = computed(() => Boolean(updatedText.value || createdText.value));

return (_ctx: any,_cache: any) => {
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    location: "end top",
    offset: 4,
    "open-on-hover": "",
    "open-delay": 200,
    "close-delay": 300,
    disabled: !hasTooltip.value
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("span", _mergeProps(props, { class: "price-list-updated" }), _toDisplayString(relative.value), 17)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (updatedText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "vp-popover-label" }, "Updated", -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(updatedText.value), 1)
            ]))
          : _createCommentVNode("", true),
        (createdText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "vp-popover-label" }, "Created", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(createdText.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, "Shown in your local time (" + _toDisplayString(localZone.value) + ")", 1)
      ])
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})